import { object, string, number } from "yup";

let overviewSchema = object({
  website: string().required("Website cannot be empty."),
  status: number().required("Status cannot be empty."),
});

export default overviewSchema;
